import * as APIModels from "../../../models";
import { useState, useEffect, useCallback } from "react";
import { DataService } from "../../../services/DataService";
import DocumentTypeRuleModal from "./modals/DocumentTypeRuleModal";
import { ClientService } from "../../../services/ClientService";
import AuthLayout from "../../../layouts/auth-layout";
import Select, { ActionMeta } from "react-select";
import Fees from "./Fees";
import TylerDocument from "./TylerDocument";

export type MyOptionType = { label: string; value: string };

export default function TylerPleadings({
    submission,
    originalDocs,
    onSelectDocument,
    onUpdateDoc,
    submissionLocked,
    securityTypes,
}: {
    submission: APIModels.Submission;
    originalDocs: APIModels.Document[];
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    onUpdateDoc: (doc: APIModels.Document) => void;
    submissionLocked?: (docHasSecurity: Map<string, boolean>) => void;
    securityTypes?: (options: MyOptionType[]) => boolean;
}) {
    type OptionalServicesType = {
        filingCodeId: string;
        optionalServiceCodes: MyOptionType2[];
    };
    type DocumentRuleStatusType = {
        documentId: string;
        status: string;
    };

    // eslint-disable-next-line prefer-const
    let documentRuleStatus = [] as DocumentRuleStatusType[];

    // eslint-disable-next-line prefer-const
    let optionalServicesOptions = [] as OptionalServicesType[];

    type MyOptionType2 = {
        label: string;
        value: string;
        amount: number;
        ePoralId: string;
    };
    let options = [] as MyOptionType[];
    let options1 = [] as MyOptionType[];
    let options2 = [] as MyOptionType[];
    let opts = [] as MyOptionType2[];

    // State Variables
    const docTypes: APIModels.DocumentType[] = [];
    const [documentTypes, setDocumentTypes] = useState(docTypes);
    const [documents, setDocuments] = useState(originalDocs);
    /*
    const [documents, setDocuments] = useState(
        submission.documents ?? ([] as APIModels.Document[])
    );
    */

    const [documentRuleStatusList, setDocumentRuleStatusList] = useState(
        [] as DocumentRuleStatusType[]
    );

    const [optionalOptions, setOptionalOptions] = useState(
        optionalServicesOptions
    );
    const [activeRow, setActiveRow] = useState(-1);
    const [filterText, setFilterText] = useState("");
    const [warning, setWarning] = useState("");
    const [loadingArray, setLoadingArray] = useState([] as boolean[]);
    const [selectedBool, setSelectedBool] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [county, setCounty] = useState(
        submission?.caseData?.countyID ?? APIModels.EmptyGuid
    );
    const [caseType, setCaseType] = useState(
        submission?.caseData?.caseTypeID ?? APIModels.EmptyGuid
    );
    const [caseNumber, setCaseNumber] = useState(
        submission?.caseData?.courtCaseNumber ?? APIModels.EmptyGuid
    );

    const [filingCodeOptions, setFilingCodeOptions] = useState(
        [] as MyOptionType[]
    );
    const [securityOptions, setSecurityOptions] = useState(
        [] as MyOptionType[]
    );
    const [filingComponentOptions, setFilingComponentOptions] = useState(
        [] as MyOptionType[]
    );

    const [selectedDocument, setSelectedDocument] = useState(
        new APIModels.Document()
    );
    const [documentSecurityTypesSelected, setDocumentSecurityTypesSelected] =
        useState<Map<string, boolean>>(new Map<string, boolean>());

    // Hard Code

    useEffect(() => {
        submission;
    }, []);

    const onFocus = (doc: APIModels.Document) => {
        onSelectDocument(
            doc,
            documents.findIndex((v) => v.id == doc.id)
        );
    };

    useEffect(() => {
        submission.documents?.forEach((d) => {
            d.description = "";
            d.optionalServices = [];
        });
    }, [submission.caseData?.countyID]);

    /*
     * If not all the booleans are true, then one of the documents
     * does not have a security type and we cannot allow the submmission
     * to be submitted.
     */

    // Effects
    // Update Documents
    useEffect(() => {
        // setDocuments(submission.documents ?? []);
        setCounty(submission?.caseData?.countyID ?? APIModels.EmptyGuid);
        setCaseType(submission?.caseData?.caseTypeID ?? APIModels.EmptyGuid);
        setCaseNumber(submission?.caseData?.courtCaseNumber ?? "");
    }, [submission]);

    useEffect(() => {
        setDocuments(originalDocs ?? []);
    }, [originalDocs]);

    const onSubmit = () => {
        console.log(documents);
    };

    const updateDocumentStatus = (documentId: string, newStatus: string) => {
        setDocumentRuleStatusList((prevRules) =>
            prevRules.map((rule) =>
                rule.documentId === documentId
                    ? { ...rule, status: newStatus }
                    : rule
            )
        );
    };
    const predictFunction = async (index: number, doc: APIModels.Document) => {
        if (caseType != APIModels.EmptyGuid) {
            setDocumentRuleStatusList((documentRuleStatusList) => [
                ...documentRuleStatusList,
                {
                    documentId: doc.id!,
                    status: "start",
                },
            ]);

            // setDocumentRuleStatusList(temp);
            const docs = [];

            const test = {
                attorneyID: submission.attorneyID,
                caseTypeID: caseType,
                claimAmount: submission.caseData?.claimAmount
                    ? parseFloat(submission.caseData?.claimAmount)
                    : submission.caseData?.smallClaimsAmount,
                countyID: submission.caseData?.countyID,
                divisionID: submission.caseData?.divisionID,
                newCase: submission.filename!.indexOf("-a-0-") > -1,
            };
            docs.push(doc);
            // console.log(loadingArray);

            ClientService.getDocType({
                body: {
                    docs: docs,
                    attorneyID: submission.attorneyID,
                    submissionID: submission.id,
                    caseTypeID: caseType,
                    claimAmount: submission.caseData?.claimAmount
                        ? parseFloat(submission.caseData?.claimAmount)
                        : submission.caseData?.smallClaimsAmount,
                    countyID: submission.caseData?.countyID,
                    divisionID: submission.caseData?.divisionID,
                    newCase: submission.filename!.indexOf("-a-0-") > -1,
                },
            })
                .then(
                    (resp) => {
                        if (resp.successful === true && resp.data) {
                            if (
                                resp.data.length > 0 &&
                                resp.data[0]?.filingCodeID !=
                                    APIModels.EmptyGuid
                            ) {
                                updateDocumentStatus(doc.id!, "valid");
                                const temp = {
                                    ...doc,
                                    documentType: resp.data[0]?.documentType,
                                    documentTypeID:
                                        resp.data[0]?.documentTypeID,
                                    filingCodeID: resp.data[0]?.filingCodeID,
                                    filingComponentID:
                                        resp.data[0]?.filingComponentID,
                                    securityID: resp.data[0]?.securityID,
                                    description: resp.data[0]?.description,
                                    comments: resp.data[0]?.comments,
                                };

                                onUpdateDoc(temp);
                            } else {
                                updateDocumentStatus(doc.id!, "missing");
                            }
                        } else {
                            updateDocumentStatus(doc.id!, "missing");
                        }
                    },
                    (error) => {
                        updateDocumentStatus(doc.id!, "missing");
                        console.log(error);
                    }
                )

                .finally(() => {
                    const temp = [...loadingArray];
                    temp.splice(index, 1, false);
                    setLoadingArray(temp);
                });
        }
    };

    useEffect(() => {
        const defaultLoading = submission.documents?.map(() => true);
        setLoadingArray(defaultLoading ?? []);
        documents?.forEach((v, i) => predictFunction(i, v));
    }, [caseType, county, caseNumber]);

    if (!submission.documents) return <div></div>;

    useEffect(() => {
        if (securityOptions.length > 0) {
            setSecurityOptions([] as MyOptionType[]);
            securityTypes && securityTypes([] as MyOptionType[]);
        }

        let options1 = [] as MyOptionType[];

        DataService.getDocumentTypesByCounty({
            countyId: county,
        }).then(
            (resp) => {
                if (resp.length > 0) {
                    options1 = resp.map((sec) => {
                        return { label: sec.name!, value: sec.id! };
                    });
                    securityTypes && securityTypes(options1);
                    console.log("Security Options", options1);
                    setSecurityOptions(options1);
                    options1 = [] as MyOptionType[];
                } else {
                    securityTypes && securityTypes([] as MyOptionType[]);
                    setErrorMessage(
                        "An error occured in accessing the api when accessing the Document Types."
                    );
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );

        if (errorMessage !== "") {
            console.log(errorMessage);
            setErrorMessage("");
        }
    }, [county]);

    useEffect(() => {
        console.log("CASE TYPE CHANGED: " + caseType);
        if (caseType != APIModels.EmptyGuid) {
            DataService.getFilingCodes({
                caseTypeId: caseType,
                newCase: submission.filename!.indexOf("-a-0-") > -1,
            }).then(
                (resp) => {
                    if (resp.length > 0) {
                        options = resp.map((codes) => {
                            return { label: codes.name!, value: codes.id! };
                        });
                        setFilingCodeOptions(options);
                        /*
    
                        if (
                            updatedDocument.filingCodeID != undefined &&
                            updatedDocument.filingCodeID != null &&
                            updatedDocument.filingCodeID != APIModels.EmptyGuid
                        ) {
                            setUpdatedDocument({
                                ...updatedDocument,
    
                                filingCode: options.find(
                                    (f) =>
                                        f.value === updatedDocument.filingCodeID
                                )?.label,
                            });
                        }
                        */

                        options = [] as MyOptionType[];
                    } else {
                        setErrorMessage(
                            "An error occured in accessing the api for the Filing Codes."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
            if (errorMessage !== "") {
                console.log(errorMessage);
                setErrorMessage("");
            }
        }
    }, [caseType]);

    // Update Filing Components
    useEffect(() => {
        DataService.getComponentsByCounty({
            countyId: county ?? "",
        }).then(
            (resp) => {
                if (resp.length > 0) {
                    options2 = resp.map((component) => {
                        return {
                            label: component.name!,
                            value: component.id!,
                        };
                    });
                    setFilingComponentOptions(options2);
                    options2 = [] as MyOptionType2[];
                } else {
                    setErrorMessage(
                        "An error occured in accessing the api when accessing the Filing Components."
                    );
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage !== "") {
            console.log(errorMessage);
            setErrorMessage("");
        }
    }, [county]);
    /********************************************************************************************************************************************************************** */

    useEffect(() => {
        //console.log("FILING CODE CHANGED!!!!!!");
    }, [documents.map((i) => i.filingCodeID)]);

    const placeholderOption = [
        {
            label: "Please Choose a Filing Code",
            value: APIModels.EmptyGuid,
        } as MyOptionType,
    ] as MyOptionType[];
    // const [updatedDocument, setUpdatedDocument] = useState(APIModels.Document);

    const [ruleModalShow, setRuleModalShow] = useState(false);
    const [manualCodeChange, setManualCodeChange] = useState(false);

    const [updatedOptServOpt, setUpdatedOptServOpt] = useState(
        [] as MyOptionType[]
    );
    // Form Choices
    const [feeTemp, setFeeTemp] = useState(new APIModels.Fee());

    const [optionalServiceTemp, setOptionalServiceTemp] = useState(
        new APIModels.OptionalServicesCode()
    );

    /*
    useEffect(() => {
        console.log("IN TYLERDOC " + JSON.stringify(updatedDocument));
        updateDocument({ ...updatedDocument });
    }, [updatedDocument]);
    */
    const UpdateFilingCode = (doc: APIModels.Document) => {
        if (filingCodeOptions.length > 0) {
            doc.filingCode = filingCodeOptions.find(
                (f) => f.value === doc.filingCodeID
            )?.label;
        }
    };

    const GetOptionalServicesRules = (doc: APIModels.Document) => {
        const tempDocList = [] as APIModels.Document[];
        if (doc.securityID == "") {
            doc.securityID = APIModels.EmptyGuid;
        }
        tempDocList.push(doc);
        ClientService.getFees({
            body: {
                docs: tempDocList,
                attorneyID: submission.attorneyID,
                filename: submission.filename,
                submissionID: submission.id,
                caseTypeID: caseType,
                countyID: submission.caseData?.countyID,
                divisionID: submission.caseData?.divisionID,
                newCase: submission.filename!.indexOf("-a-0-") > -1,
                documentCount: documents.reduce(
                    (sum, document) => sum + document.pageCount!,
                    0
                ),
            },
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    const tempFeeList = [] as APIModels.OptionalServicesCode[];

                    resp.data.forEach(async (element) => {
                        const tempService =
                            new APIModels.OptionalServicesCode();
                        tempService.name = element?.description;
                        tempService.quantity = element?.quantity;
                        tempService.fee = element?.amount;
                        tempService.id = optionalOptions!
                            .find((f) => f.filingCodeId == doc.filingCodeID)
                            ?.optionalServiceCodes.find(
                                (i, v) => i.ePoralId === element.ePortalID
                            )?.value;
                        tempFeeList.push(tempService);

                        //AddOptionalServices(tempService);
                    });
                    if (tempFeeList.length > 0) {
                        AddOptionalServices(tempFeeList, doc);
                    }
                } else {
                    console.log(
                        "calling GetOptionalServices FAILED " + doc.filingCodeID
                    );
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const GetOptionalServicesOptions = (doc: APIModels.Document) => {
        if (doc.filingCodeID != APIModels.EmptyGuid) {
            DataService.getOptServByFilingCode({
                countyId: county,
                filingCodeId: doc.filingCodeID ?? "",
            }).then(
                (resp) => {
                    if (resp.length > 0) {
                        opts = resp.map((opts) => {
                            return {
                                label: opts.name!,
                                value: opts.id!,
                                amount: opts.fee!,
                                ePoralId: opts.ePortalID ?? "",
                            };
                        });
                        console.log(
                            "GetOptionalServicesOptions: " +
                                JSON.stringify(opts)
                        );
                        setOptionalOptions((optionalOptions) => [
                            ...optionalOptions,
                            {
                                filingCodeId: doc.filingCodeID!,
                                optionalServiceCodes: opts,
                            },
                        ]);
                        /*
                        optionalServicesOptions.push({
                            filingCodeId: doc.filingCodeID!,
                            optionalServiceCodes: options,
                        });
                        */
                        //options = [] as MyOptionType[];
                    } else {
                        setErrorMessage(
                            "An error occured in accessing the api when accessing the Optional Services."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
            if (errorMessage !== "") {
                console.log(errorMessage);
                setErrorMessage("");
            }
        }
    };

    const AddOptionalServices = (
        codes: APIModels.OptionalServicesCode[],
        doc: APIModels.Document
    ) => {
        onUpdateDoc({
            ...doc,
            optionalServices: codes,
        });
    };

    const ManualCodeChange = (doc: APIModels.Document) => {
        const tempComp = filingComponentOptions.find(
            (c) => c.label.trimEnd().toLocaleLowerCase() === "lead document"
        );

        const tempSec = securityOptions.find(
            (c) =>
                c.label.trimEnd().toLocaleLowerCase() === "public" ||
                c.label
                    .trimEnd()
                    .toLocaleLowerCase()
                    .includes("not contain sensitive")
        );

        onUpdateDoc({
            ...doc,
            filingComponentID: tempComp ? tempComp.value : "",
            //securityID: tempSec ? tempSec?.value : "",
            description: filingCodeOptions.find(
                (f) => f.value === doc.filingCodeID
            )?.label,
        });
    };

    // On Changes
    const onCodeChange = (
        value: MyOptionType | null,
        doc: APIModels.Document
    ) => {
        onUpdateDoc({
            ...doc,
            filingCodeID: value?.value,
            filingCode: filingCodeOptions.find((f) => f.value === value?.value)
                ?.label,
        });
        ManualCodeChange(doc);
    };

    const onCompChange = (
        value: MyOptionType | null,
        doc: APIModels.Document
    ) => {
        onUpdateDoc({
            ...doc,
            filingComponentID: value?.value,
        });
    };

    const onSecChange = (
        value: MyOptionType | null,
        doc: APIModels.Document
    ) => {
        onUpdateDoc({
            ...doc,
            securityID: value?.value,
        });

        console.log({
            "lockSubmission debug onSecChange": documentSecurityTypesSelected,
        });
        // now to change the map of docHasSecurity
        if (documentSecurityTypesSelected && value) {
            const clone = documentSecurityTypesSelected;
            clone.set(
                doc.id ?? APIModels.EmptyGuid,
                value.value !== undefined ||
                    value.value !== null ||
                    value.value !== ""
            );
            setDocumentSecurityTypesSelected(clone);
            console.log({ "lockSubmission debug onSecChange clone": clone });
            submissionLocked && submissionLocked(clone);
        }
    };

    const onDescChange = (value: string, doc: APIModels.Document) => {
        onUpdateDoc({
            ...doc,
            description: value,
        });
    };

    const onOptServChange = (
        value: MyOptionType | null,
        doc: APIModels.Document
    ) => {
        const tempService = new APIModels.OptionalServicesCode();
        tempService.id = value?.value;
        tempService.name = value?.label;
        tempService.fee = optionalOptions!
            .find((f) => f.filingCodeId == doc.filingCodeID)
            ?.optionalServiceCodes.find(
                (i, v) => i.value === value?.value
            )?.amount;
        setOptionalServiceTemp(tempService);
    };
    const onDeleteOptServ = (
        value: APIModels.OptionalServicesCode,
        doc: APIModels.Document
    ) => {
        const tempService = new APIModels.OptionalServicesCode();

        const documentOptions = [...doc!.optionalServices!];
        documentOptions.splice(documentOptions.indexOf(value), 1);
        doc.optionalServices = documentOptions;
        onUpdateDoc({
            ...doc,
            optionalServices: documentOptions,
        });
    };

    const onQuantityChange = (value: number, doc: APIModels.Document) => {
        optionalServiceTemp.quantity = value;
        feeTemp.quantity = value;
    };

    const onAddButton = (doc: APIModels.Document) => {
        if (!doc.optionalServices) {
            doc.optionalServices = [];
        }
        if (optionalServiceTemp.name && optionalServiceTemp.quantity) {
            setWarning("");
            if (
                doc.optionalServices === undefined ||
                doc.optionalServices === null
            ) {
                doc.optionalServices = [] as APIModels.OptionalServicesCode[];
            }

            const documentOptions = [
                ...doc.optionalServices,
                optionalServiceTemp,
            ];
            // doc.optionalServices = documentOptions;
            onUpdateDoc({
                ...doc,
                optionalServices: documentOptions,
            });

            setOptionalServiceTemp(new APIModels.OptionalServicesCode());
        } else if (!optionalServiceTemp.name) {
            setWarning("Please Select a Service.");
        } else if (!optionalServiceTemp.quantity) {
            setWarning("Please Select a Quantity.");
        }
    };
    const openRuleModal = (doc: APIModels.Document) => {
        //setSelectedDocument(doc);
        setRuleModalShow(true);
    };

    const onAddDocTypeRule = (doc: APIModels.Document) => {
        console.log(doc.optionalServices);
        setSelectedDocument(doc);
        setRuleModalShow(true);
    };

    return (
        <>
            <div>
                {ruleModalShow && (
                    <DocumentTypeRuleModal
                        show={ruleModalShow}
                        attorneyId={submission.attorneyID ?? ""}
                        county={submission.caseData?.county}
                        division={submission.caseData?.division}
                        document={selectedDocument}
                        filingCode={
                            filingCodeOptions.find(
                                (f) => f.value === selectedDocument.filingCodeID
                            )?.label ?? ""
                        }
                        filingComponent={
                            filingComponentOptions.find(
                                (f) =>
                                    f.value ===
                                    selectedDocument.filingComponentID
                            )?.label ?? ""
                        }
                        securityType={
                            securityOptions.find(
                                (f) => f.value === selectedDocument.securityID
                            )?.label ?? ""
                        }
                        portalIdentifier={submission.portalIdentifier!}
                        onSave={() => setRuleModalShow(false)}
                        onClose={() => setRuleModalShow(false)}
                    />
                )}
            </div>

            <div className="mb-3">
                {documents?.map((doc, i) => {
                    useEffect(() => {
                        doc.filingCode = filingCodeOptions.find(
                            (f) => f.value === doc.filingCodeID
                        )?.label;
                        GetOptionalServicesOptions(doc);
                        // GetOptionalServicesRules(doc);
                    }, [doc.filingCodeID]);

                    useEffect(() => {
                        GetOptionalServicesRules(doc);
                    }, [
                        optionalOptions!.find(
                            (f) => f.filingCodeId == doc.filingCodeID
                        ),
                    ]);

                    useEffect(() => {
                        if (submission.portalIdentifier == "NC") {
                            DataService.getDocumentTypesByFilingCode({
                                countyId: submission.caseData?.countyID ?? "",
                                filingCode: doc.filingCodeID ?? "",
                            }).then(
                                (resp) => {
                                    if (resp.length > 0) {
                                        options1 = resp.map((sec) => {
                                            return {
                                                label: sec.name!,
                                                value: sec.id!,
                                            };
                                        });
                                        securityTypes &&
                                            securityTypes(options1);
                                        setSecurityOptions(options1);
                                        if (doc.securityID) {
                                            const sec = options1.find(
                                                (option) => {
                                                    return (
                                                        option.value ==
                                                        doc.securityID
                                                    );
                                                }
                                            );
                                            onSecChange(sec ?? null, doc);
                                        }
                                    } else {
                                        securityTypes && securityTypes([]);
                                        setErrorMessage(
                                            "An error occured in accessing the api when accessing the Document Types."
                                        );
                                    }
                                },
                                (error) => {
                                    setErrorMessage(error);
                                }
                            );
                        }
                    }, [doc.filingCodeID]);

                    return (
                        <>
                            <div className="row">
                                <div
                                    className="col-sm-12"
                                    style={{
                                        height: 40,
                                        verticalAlign: "center",
                                        lineHeight: "40px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <em>{doc.filename}</em>
                                </div>
                            </div>

                            <div className="row">
                                <div
                                    className="col-12"
                                    style={{
                                        display: "inline-block",
                                        position: "relative",
                                        float: "left",
                                        //clear: "both",
                                    }}
                                >
                                    {documentRuleStatusList.find(
                                        (d) => d!.documentId! == doc.id
                                    )?.status == "valid" ? (
                                        <i
                                            className="fas fa-check-circle"
                                            style={{
                                                color: "green",
                                                fontSize: "30px",
                                            }}
                                        ></i>
                                    ) : documentRuleStatusList.find(
                                          (d) => d!.documentId! == doc.id
                                      )?.status == "missing" ? (
                                        <i
                                            className="fas fa-times-circle"
                                            style={{
                                                color: "red",
                                                fontSize: "30px",
                                            }}
                                        ></i>
                                    ) : documentRuleStatusList.find(
                                          (d) => d!.documentId! == doc.id
                                      )?.status == "start" ? (
                                        <div className="spinner-border text-warning m-2"></div>
                                    ) : (
                                        <i
                                            className="fas fa-exclamation-triangle"
                                            style={{
                                                color: "orange",
                                                fontSize: "30px",
                                            }}
                                        ></i>
                                    )}
                                </div>{" "}
                                <div className="col-12">
                                    <button
                                        style={{
                                            display: "inline-block",
                                            position: "relative",
                                            float: "right",
                                            //clear: "both",
                                        }}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={() => {
                                            onAddDocTypeRule(doc);
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <label
                                        htmlFor="selComponent"
                                        className="form-label"
                                    >
                                        Component
                                    </label>
                                    <Select
                                        id="selComponent"
                                        name="selComponent"
                                        value={filingComponentOptions.filter(
                                            (i, v) =>
                                                i.value ===
                                                doc.filingComponentID?.toLowerCase()
                                        )}
                                        options={
                                            filingComponentOptions.length > 0
                                                ? filingComponentOptions
                                                : placeholderOption
                                        }
                                        onChange={(o, m) =>
                                            onCompChange(o, doc)
                                        }
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <label
                                        htmlFor="selFilingCode"
                                        className="form-label"
                                    >
                                        Filing Code
                                    </label>
                                    <Select<any, false, any>
                                        id="selFilingCode"
                                        name="selFilingCode"
                                        value={filingCodeOptions.filter(
                                            (i, v) =>
                                                i.value ===
                                                doc.filingCodeID?.toLowerCase()
                                        )}
                                        options={filingCodeOptions}
                                        onChange={(o, m) => {
                                            onCodeChange(o, doc);
                                        }}
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <label
                                        htmlFor="selSecurity"
                                        className="form-label"
                                    >
                                        Security
                                    </label>
                                    <Select
                                        id="selSecurity"
                                        name="selSecurity"
                                        value={securityOptions.filter(
                                            (i, v) =>
                                                i.value ===
                                                doc.securityID?.toLowerCase()
                                        )}
                                        options={
                                            securityOptions.length > 0
                                                ? securityOptions
                                                : placeholderOption
                                        }
                                        onChange={(o, m) => onSecChange(o, doc)}
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <label
                                        htmlFor="txtDocDesc"
                                        className="form-label"
                                    >
                                        Description
                                    </label>
                                    <input
                                        id="txtDocDesc"
                                        name="txtDocDesc"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Description"
                                        value={doc.description}
                                        onChange={(event) => {
                                            onDescChange(
                                                event.currentTarget.value,
                                                doc
                                            );
                                        }}
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <label
                                        htmlFor="txtDocDesc"
                                        className="form-label"
                                    >
                                        Selected Services
                                    </label>
                                    <table style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <td style={{ width: "69%" }}>
                                                    Service
                                                </td>
                                                <td>Quantity</td>
                                                <td>Amount</td>
                                            </tr>
                                            {doc.optionalServices?.length ? (
                                                doc.optionalServices?.map(
                                                    (fee) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    {fee?.name}
                                                                </td>
                                                                <td>
                                                                    {
                                                                        fee?.quantity
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {fee?.fee?.toFixed(
                                                                        2
                                                                    ) ?? ""}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        className="btn"
                                                                        type="button"
                                                                        onClick={() =>
                                                                            onDeleteOptServ(
                                                                                fee,
                                                                                doc
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="ri-delete-bin-2-line"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )
                                            ) : (
                                                <tr>
                                                    <td>
                                                        Select an Optional
                                                        Service{" "}
                                                        <em>if needed.</em>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8">
                                    <label
                                        htmlFor="selServices"
                                        className="form-label"
                                    >
                                        Optional Services
                                    </label>
                                    <Select
                                        id="selServices"
                                        name="selServices"
                                        options={
                                            optionalOptions!.find(
                                                (f) =>
                                                    f.filingCodeId ==
                                                    doc.filingCodeID
                                            )?.optionalServiceCodes
                                        }
                                        onChange={(o, m) =>
                                            onOptServChange(o, doc)
                                        }
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                                <div className="col-2">
                                    <label
                                        htmlFor="txtServiceQuant"
                                        className="form-label"
                                    >
                                        Quantity
                                    </label>
                                    <input
                                        id="txtServiceQuant"
                                        name="txtServiceQuant"
                                        type="number"
                                        className="form-control"
                                        onChange={(e) => {
                                            onQuantityChange(
                                                e.currentTarget.valueAsNumber,
                                                doc
                                            );
                                        }}
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                                <div className="col-2">
                                    <label
                                        htmlFor="txtFeeAmount"
                                        className="form-label"
                                    >
                                        Amount
                                    </label>
                                    <input
                                        id="txtFeeAmount"
                                        name="txtFeeAmount"
                                        type="number"
                                        className="form-control"
                                        readOnly
                                        value={
                                            optionalServiceTemp?.fee?.toFixed(
                                                2
                                            ) ?? ""
                                        }
                                        onFocus={() => {
                                            onSelectDocument(doc, i);
                                        }}
                                    />
                                </div>
                                <div className="col-2">
                                    <span style={{ height: "10px" }}></span>
                                    <button
                                        className={"btn btn-primary"}
                                        type="button"
                                        onClick={() => {
                                            onAddButton(doc);
                                        }}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                            {warning !== "" && (
                                <div className="row mb-3">
                                    <span style={{ height: "10px" }}></span>
                                    <div style={{ width: "100%" }}>
                                        <p className="alert alert-warning">
                                            <strong>Note:&nbsp;</strong>
                                            {warning}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </>
                    );
                })}
            </div>
        </>
    );
}

const styles = {
    missing: {
        border: "2px solid #ff0000",
    },
    valid: {
        border: "2px solid #00ff00",
    },
    warning: {
        border: "2px solid #FFFF00",
    },
};
